export const videosData = [
    {
        title: 'Herdling Reveal Trailer',
        youtubeLink: 'https://www.youtube.com/watch?v=tUEcKBVzhQg',
    },
    {
        title: 'FAR: Changing Tides | Feature Reveal Trailer',
        youtubeLink: 'https://www.youtube.com/watch?v=r0odfW_g4Lk',
    },
];
